import {useEffect, useState} from "react";
import {useRecoilState, useRecoilValue} from "recoil";
import {beaconSelector} from "../recoil/selector";
import useBeacon, {ClkBtnSubEventNm, IClkBtnOptionProperties} from "../hooks/useBeacon";
import {PAGE_NM} from "../types/types";
import {useLocation} from "react-router-dom";
import * as Atom from "../recoil";
import CALL_TIME from '../../assets/images/feature/feature-call-time.png';
import {useBaseParam} from "../hooks/useBaseParam";
import {mutateHouseLoanExecute} from "../../infra/api/mtg/mutateHouseLoanExecute";
import useNav from "../hooks/useNav";


interface ICallTime {
    text: string;
    value: string;
}
export const useMtgCallTime = () => {
    const {navigate} = useNav();
    const [isOpen, setOpen] = useState<boolean>(false);
    const beaconData = useRecoilValue(beaconSelector);
    const beacon = useBeacon({
        mediaCd: beaconData.mediaCd,
        custSeq: beaconData.custSeq,
        srcCd: beaconData.srcCd,
        pageName: isOpen ? PAGE_NM.MTG_CALL_REQ : PAGE_NM.MTG_CALL_TIME,
    });
    const sendBeaconClkBtn = (subEventNm: string, properties: any) => {
        beacon.sendClkBtn({
            events: { subEventName: subEventNm },
            properties:
                typeof properties === 'string' ? { btnNm: properties } : properties,
        });
    };

    const sendBeaconClkBtnOption = (
        {btmsheet_name, option_name, before_option_name,
    }: IClkBtnOptionProperties) => {
      beacon.sendClkBtnOption({
        properties: <IClkBtnOptionProperties>{
          btmsheet_name: btmsheet_name,
          option_name: option_name,
          before_option_name: before_option_name,
        },
      });
    };

    useEffect(() => {
        beacon.sendViewPage();
    }, []);

    const location:any = useLocation();
    const callInfo = location.state;
    const [ctgGrpList] = useRecoilState(Atom.commonCodes);
    const callList = ctgGrpList
        .filter((item:any) => item.codeGrp === 'C052')[0].list
        .map((item:any) => {
            return {
                text: item.codeNm,
                value: item.code
            }
        })
    const [selected, setSelected] = useState<ICallTime>({ text: '', value: '' });
    const clickItem = (item: ICallTime) => {
        sendBeaconClkBtnOption({
            btmsheet_name: "전화 안내 신청을 완료해주세요",
            before_option_name: selected.text,
            option_name: item.text
        });
        setSelected(item);
        setOpen(true);
    };
    const clickCallTimeConfirm = async (e: any) => {
        await putConsultApply();
        sendBeaconClkBtn(ClkBtnSubEventNm.Next, e.target.innerHTML);
        setOpen(false);
        navigate('/mtg/result-complete', {state: callInfo});
    };

    const mutateConsultApply = useBaseParam(mutateHouseLoanExecute, {
        preRequestDtlNo: callInfo.preRequestDtlNo,
        hopeConsultTimeCd: selected.value
    });
    const putConsultApply = async () => {
        await mutateConsultApply()
    }
    const close = () => {
        setOpen(false);
    }

    return {
        callList,
        selected,
        clickItem,
        isOpen,
        callInfo,
        clickCallTimeConfirm,
        CALL_TIME,
        close
    }
}